import RestApiModel from "@/api/Model/RestApiModel";
import api from "../index";

class Dynamic extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-dynamic-documents-ipr';
  }

  static setActive(id, params) {
    return api.patch(this.getResourceIdEndpoint(id, 'set-active'), params);
  }

  static update(id, params) {
    return api.post(this.getResourceIdEndpoint(id), params);
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

  static getType(id) {
    return api.get(this.getResourceEndpoint() + '/type/' + id);
  }

  static listByType(typeId) {
    return api.get(this.getResourceEndpoint() + '/list-by-type/' + typeId);
  }

  static downloadDocument(id, guid)  {
    return api.get(this.getResourceIdEndpoint(id) + '/document/' + guid,  { responseType: 'arraybuffer' });
  }
}

export default Dynamic;
